import $const from '@/utils/const'

let _ = require('lodash')
const CommonService = {
    getRateDataChart (rateData, reactionData) {
        let dataChart = _.concat(rateData, reactionData)
        let dataChartGroupByDay = _.groupBy(dataChart, item => item.day)
        let labels = []
        _.forEach(dataChartGroupByDay, (value, key) => labels.push(key))
        let labelsSorted = _.sortBy(labels)
        let oneStarDataSet = []
        let twoStarDataSet = []
        let threeStarDataSet = []
        let fourStarDataSet = []
        let fiveStarDataSet = []
        let likeDataSet = []
        let dislikeDataSet = []
        _.forEach(labelsSorted, val => {
            let dataByDay = dataChartGroupByDay[val]
            let oneStar = 0
            let twoStar = 0
            let threeStar = 0
            let fourStar = 0
            let fiveStar = 0
            let like = 0
            let dislike = 0
            let idxOneStar = _.findIndex(dataByDay, o => o.one_star !== undefined)
            if (idxOneStar > -1) {
                oneStar = dataByDay[idxOneStar].one_star
            }
            let idxTwoStar = _.findIndex(dataByDay, o => o.two_star !== undefined)
            if (idxTwoStar > -1) {
                twoStar = dataByDay[idxTwoStar].two_star
            }
            let idxThreeStar = _.findIndex(dataByDay, o => o.three_star !== undefined)
            if (idxThreeStar > -1) {
                threeStar = dataByDay[idxTwoStar].three_star
            }
            let idxfourStar = _.findIndex(dataByDay, o => o.four_star !== undefined)
            if (idxfourStar > -1) {
                fourStar = dataByDay[idxfourStar].four_star
            }
            let idxFiveStar = _.findIndex(dataByDay, o => o.five_star !== undefined)
            if (idxFiveStar > -1) {
                fiveStar = dataByDay[idxFiveStar].five_star
            }
            let idxLike = _.findIndex(dataByDay, o => o.likes !== undefined)
            if (idxLike > -1) {
                like = dataByDay[idxLike].likes
            }
            let idxDislike = _.findIndex(dataByDay, o => o.dislikes !== undefined)
            if (idxDislike > -1) {
                dislike = dataByDay[idxDislike].dislikes
            }
            oneStarDataSet.push(oneStar)
            twoStarDataSet.push(twoStar)
            threeStarDataSet.push(threeStar)
            fourStarDataSet.push(fourStar)
            fiveStarDataSet.push(fiveStar)
            likeDataSet.push(like)
            dislikeDataSet.push(dislike)
        })
        return {
            labels: labelsSorted,
            dataSets: [
                {
                    label: '1 star',
                    yAxisID: 'y-axis-1',
                    backgroundColor: $const.rateColors1to5[0],
                    stack: 'Stack 1',
                    data: [...oneStarDataSet]
                },
                {
                    label: '2 stars',
                    yAxisID: 'y-axis-1',
                    backgroundColor: $const.rateColors1to5[1],
                    stack: 'Stack 1',
                    data: [...twoStarDataSet]
                },
                {
                    label: '3 stars',
                    yAxisID: 'y-axis-1',
                    backgroundColor: $const.rateColors1to5[2],
                    stack: 'Stack 1',
                    data: [...threeStarDataSet]
                },
                {
                    label: '4 stars',
                    yAxisID: 'y-axis-1',
                    backgroundColor: $const.rateColors1to5[3],
                    stack: 'Stack 1',
                    data: [...fourStarDataSet]
                },
                {
                    label: '5 stars',
                    yAxisID: 'y-axis-1',
                    backgroundColor: $const.rateColors1to5[4],
                    stack: 'Stack 1',
                    data: [...fiveStarDataSet]
                },
                {
                    label: 'Like',
                    yAxisID: 'y-axis-2',
                    backgroundColor: '#1E88E5',
                    stack: 'Stack 2',
                    data: [...likeDataSet]
                },
                {
                    label: 'Dislike',
                    yAxisID: 'y-axis-2',
                    backgroundColor: '#E53935',
                    stack: 'Stack 2',
                    data: [...dislikeDataSet]
                }
            ]
        }
    }
}
export default CommonService
